<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  import router from '@/router'
  import utils from '@/utils'
  import config from '@/config'
  import { getCookie } from '@/store/cookies'
import { mapActions } from 'vuex'
export default {
  name: 'app',
  provide () {
    return {
      reload: this.reload
    }
  },
  watch: {
    '$route': {
      handler (to, from, next) {
        var d = to.query.domain
        var oldd = from.query.domain
        if (d != oldd) {
          this.redirectToCorrectUrl() // 手动输入地址并强制刷新浏览器后的domain转到正确的地址
        }
      }
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    ...mapActions('auth', ['getBusinessIdByCode', 'toOtherDomain']),
    ...mapActions('dropdowns', ['getAllDropdowns', 'getBusinessIds']),
    redirectToCorrectUrl () {
      var oldOrg;
      if (getCookie('org')) {
        oldOrg = getCookie('org')
      }
      var domain = utils.getQueryString('domain')
      this.getBusinessIdByCode(domain).then((r) => {
        if (r) {
          this.toOtherDomain(r[0])
        } else {
          // this.$toasted.show('请检查地址栏输入,该domain不存在')
          this.toOtherDomain({domain: 'inesa.byl.sh.cn', businessId: ''})
        }
      })
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">
  @import "./assets/scss/input";
  @import "./assets/scss/admin";
  @import "./assets/scss/style";
  @import "./assets/scss/main";
  @import "./assets/scss/zhicheng.scss";
  @import "./assets/scss/onsite.scss";
  @import "./assets/scss/member";
  @import "./assets/scss/main_mine";
  @import "./assets/scss/main_mine_byl.scss";
  @import "./assets/scss/main_mine_continueEdu.scss";
  @import "./assets/scss/main_mine_entrain.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue